import React from "react";

const TermsCondition = () => {
  return (
    <section className="section-padding">
      <div className="container">
        <div className="row">
          <div className="col-lg-10 col-12 mx-auto policy-content">
            <h1>Terms and Conditions for Use of Curenza</h1>
            <p>
              <em>
                A Product by Omshakthi Monitoring Service, Bangalore, India
              </em>
            </p>
            <p>
              <strong>Effective Date :</strong> 30 May 2025
            </p>
            <div className="content">
              <section>
                <h2>1. Introduction</h2>
                <p>
                  These Terms and Conditions ("Terms") constitute a legally
                  binding agreement between you ("User") and Omshakthi
                  Monitoring Service ("Company"), a company incorporated under
                  the laws of India, regarding your use of the facility
                  management platform Curenza(Omshakthi Monitoring Service
                  Private Limited).
                </p>
                <p>
                  By accessing or using the platform, you signify your
                  acceptance of these Terms. If you do not agree, you must not
                  use the platform.
                </p>
              </section>

              <section>
                <h2>2. Services</h2>
                <p>
                  Curenza(Omshakthi Monitoring Service Private Limited) enables
                  users to request, schedule, and manage facility management
                  services via third-party service providers ("Vendors"). These
                  services include but are not limited to plumbing, electrical
                  work, waste management, and general maintenance.
                </p>
              </section>

              <section>
                <h2>3. Eligibility</h2>
                <p>
                  Users must be 18 years of age or older. By using the platform,
                  you confirm that you are legally capable of entering into
                  contracts under Indian law.
                </p>
              </section>

              <section>
                <h2>4. Independent Vendor Disclaimer</h2>
                <p>
                  Vendors listed on Curenza(Omshakthi Monitoring Service Private
                  Limited) operate as independent contractors. OMS does not
                  control or manage vendor operations and assumes no
                  responsibility for vendor actions, performance, or delays.
                  Vendor services are provided “as is.”
                </p>
              </section>

              <section>
                <h2>5. Payment & Refund Policy</h2>
                <p>
                  Payments are processed via Razorpay. Refunds, when approved,
                  are made to the original payment method in accordance with
                  Razorpay and banking policies. Refunds are only applicable in
                  cases of non-performance or platform-specific technical
                  failure.
                </p>
              </section>

              <section>
                <h2>6. Limitation of Liability</h2>
                <p>OMS shall not be liable for:</p>
                <ul>
                  <li>
                    Any damages, injury, or loss caused by vendor services;
                  </li>
                  <li>Failure or delay due to user error or force majeure;</li>
                  <li>Any consequential or incidental damages.</li>
                </ul>
                <p>
                  OMS liability is strictly limited to platform malfunctions
                  (e.g., duplicate charges, failed booking notifications).
                </p>
              </section>

              <section>
                <h2>7. Prohibited Conduct</h2>
                <p>Users may not:</p>
                <ul>
                  <li>Use the platform for unlawful or fraudulent purposes;</li>
                  <li>Misrepresent information or impersonate others;</li>
                  <li>Harass vendors or OMS staff.</li>
                </ul>
              </section>

              <section>
                <h2>8. Changes to Terms</h2>
                <p>
                  OMS reserves the right to modify these Terms at any time.
                  Users will be notified of significant changes, and continued
                  use of the platform constitutes acceptance of updated Terms.
                </p>
              </section>

              <section>
                <h2>9. Governing Law and Jurisdiction</h2>
                <p>
                  These Terms are governed by the laws of India. Disputes shall
                  be subject to the exclusive jurisdiction of the courts in
                  Bangalore, Karnataka.
                </p>
              </section>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TermsCondition;
